import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.scss";
import "leaflet/dist/leaflet.css";

import Home from "./pages/Home";
import RootLayout from "./pages/Root";
import { Fragment, Suspense, lazy } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./components/PrivateRoute";
import FallbackSpinner from "./components/FallbackSpinner";
import Loans from "./pages/Loans";
import PropertyLookup from "./pages/PropertyLookup";
import CountyMap from "./pages/CountyMap";
import StripeReturn from "./pages/StripeReturn";
import Dmedashboard from "./pages/dmedashboard";
import DealCalculator from "./pages/DealCalculator";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import CountyTest from "./pages/CountyTest";
import Login from "./pages/index.jsx";
import { AuthProvider } from "./pages/authContext"
import CityResearch from "./pages/CityResearch.jsx";
import SkipTrace from "./pages/SkipTrace.jsx";
import RentCast from "./pages/RentCast.jsx";
import ZillowDescriptionFetcher from "./pages/ZillowDescriptionFetcher.jsx";
import Login2 from "./pages/index2.jsx";
import SupportPage from "./pages/index3.js";
import RedirectToLoans from "./pages/RedirectToLoans.js";
import RedirectToInsurance from "./pages/RedirectToInsurance.js";
import ZillowClonePage from "./pages/ZillowClonePage.jsx";
import DealExplorer2 from "./pages/DealExplorer2.jsx";
import OffMarket from "./pages/OffMarket.jsx";
import OffMarketListings from "./pages/OffMarketListings.jsx";
import PropertysOffMarketMap from "./pages/PropertysOffMarketMap.jsx";
import Login3 from "./pages/index4.jsx";
import Dashboard from "./pages/AdminDashboard.jsx";
import Register from "./pages/Register.jsx";
import AnnouncementsPage from "./components/AnnouncementsPage.jsx";
import Community from "./components/Community.jsx";
// import Dashboard from "./pages/AdminDashboard.jsx";
import PropertyManagementDashboard     from "../src/propertyManagement/pages/Dashboard";
import Properties    from "../src/propertyManagement/pages/Properties";
import Tenants       from "../src/propertyManagement/pages/Tenants";
import Leases        from "../src/propertyManagement/pages/Leases";
import Maintenance   from "../src/propertyManagement/pages/Maintenance";
import Payments      from "../src/propertyManagement/pages/Payments.jsx"
import PMLayout from "./propertyManagement/PMLayout.jsx";
import PropertyDetail from "./propertyManagement/pages/PropertyDetail.js";
import DealExplorerAi from "./pages/DealExplorerAi.jsx";
import DealExplorer3 from "./pages/DealExplorer3.jsx";
import ApplicantsPage from "./propertyManagement/pages/ApplicantsPage.jsx";
import ApplicantDetailPage from "./propertyManagement/pages/ApplicantDetailPage.jsx";
import WorkOrdersPage from "./propertyManagement/pages/WorkOrdersPage.jsx";
import AddWorkOrderPage from "./propertyManagement/pages/AddWorkOrderPage.jsx";
import VendorDetailScreen from "./propertyManagement/pages/VendorDetailScreen.jsx";
import VendorsPage from "./propertyManagement/pages/VendorsPage.jsx";
import AddVendorPage from "./propertyManagement/pages/AddVendorPage.jsx";
import TenantLayout from "./layouts/TenantLayout.jsx";
import TenantDashboard from "./pages/tenant/TenantDashboard.jsx";
import CreateRequest from "./pages/tenant/CreateRequest.jsx";
import RequestDetail from "./pages/tenant/RequestDetail.jsx";
import MakePayment from "./pages/tenant/MakePayment.jsx";
import ReviewPayment from "./pages/tenant/ReviewPayment.jsx";
import PaymentProcessing from "./pages/tenant/PaymentProcessing.jsx";
import ThankYou from "./pages/tenant/ThankYou.jsx";
import VendorDashboard from "./vendor/VendorDashboard.jsx";
import VendorLayout from "./vendor/VendorLayout.jsx";
import PMWorkOrderDetail from "./propertyManagement/pages/PMWorkOrderDetail.jsx";
import PMReviewPayment from "./propertyManagement/pages/PMReviewPayment.jsx";
import PMPaymentProcessing from "./propertyManagement/pages/PMPaymentProcessing.jsx";
import PMPaymentComplete from "./propertyManagement/pages/PMPaymentComplete.jsx";
import Documents from "./pages/tenant/Documents.jsx";
import LeaseSigner from "./pages/tenant/LeaseSigner.jsx";
import ListingsPage from "./propertyManagement/leasing/ListingsPage.jsx";
import ListingDetailPage from "./propertyManagement/leasing/ListingsDetailPage.jsx";
import PublicListingsPage from "./propertyManagement/leasing/PublicListings.jsx";
import PublicListingDetail from "./propertyManagement/leasing/PublicListingDetail.jsx";
import PropertyDetailPage from "./propertyManagement/pages/PropertyDetail.jsx";
import AddProperty from "./propertyManagement/pages/AddProperty.jsx";
import Banking from "./propertyManagement/pages/Banking.jsx";
import BankDetail from "./propertyManagement/pages/BankDetail.jsx";
import InternalDash from "./vendor/InternalDashboard.jsx";
import Landing from "./pages/landing.jsx";
import LeadFeed from "./pages/LeadFeed.jsx";
import FbGroupCommentsDashboard from "./pages/FbGroupCommentsDashboard.jsx";
import FbBuyerDash from "./pages/FbBuyerDash.jsx";
import FbSellerLeadsDashboard   from "./pages/FbSellerLeadsDashboard.jsx";
import NdSellerLeadsDashboard   from "./pages/NdSellerLeadsDashboard.jsx";
import NdSellerDash from "./pages/NdSellerDash.jsx";
import FbMarketplaceLeadsDashboard from "./pages/FbMarketplaceLeadsDashboard.jsx";
import FbDiscoveredGroupsDashboard from "./pages/FbDiscoveredGroupsDashboard.jsx";
import TravelAgentDashboard from "./pages/TravelAgentDashboard.jsx";
import AmazonDashboard from "./pages/AmazonDashboard.jsx";
import { Box } from "@mui/material";
import PropertyGuys from "./pages/PropertyGuys.jsx";
import PropertyGuysDashboard from "./pages/PropertyGuysDashboard.jsx";
import CallTrackingDashboard from "./pages/CallTrackingDashboard.jsx";
import LiveDash from "./pages/LiveDash.jsx";
import InsuranceLeadFeed from "./pages/InsuranceLeadFeed.jsx";
const FindGroups = lazy(() => import("./pages/FindGroups"));
const SignIn = lazy(() => import("./pages/SignIn"));
const SignUp = lazy(() => import("./pages/SignUp"));
const Offers = lazy(() => import("./pages/Offers"));
const Profile = lazy(() => import("./pages/Profile"));
const CreateListing = lazy(() => import("./pages/CreateListing"));
const EditListing = lazy(() => import("./pages/EditListing"));
const Listing = lazy(() => import("./pages/Listing"));
const Category = lazy(() => import("./pages/Category"));
const ErrorPage = lazy(() => import("./pages/Error"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: (
      <Suspense fallback={<FallbackSpinner />}>
        <Login/>
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: "profile",
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<FallbackSpinner />}>
                <Profile />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "create-listing",
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<FallbackSpinner />}>
                <CreateListing />
              </Suspense>
            ),
          },
        ],
      },
{
  path: "listings",
  children: [
    {
      index: true,
      element: <PublicListingsPage />
    },
    {
      path: ":id",
      element: <PublicListingDetail />
    }
  ]
},

      {
        path: "edit-listing/:listingId",
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<FallbackSpinner />}>
                <EditListing />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "sign-in",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "landing",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Landing />
          </Suspense>
        ),
      },
      {
        path: "pp",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login2 />
          </Suspense>
        ),
      },
      {
        path: "termsofservice",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login3 />
          </Suspense>
        ),
      },
      {
        path: "admindashboard",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "privacypolicy",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Login3 />
          </Suspense>
        ),
      },
      {
        path: "insuranceleadfeed",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <InsuranceLeadFeed />
          </Suspense>
        ),
      },
      {
        path: "insurance",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <RedirectToInsurance />
          </Suspense>
        ),
      },
      {
        path: "support",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <SupportPage />
          </Suspense>
        ),
      },
      {
        path: "sign-up",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <SignUp />
          </Suspense>
        ),
      },
      {
        path: "leadfeed",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <LeadFeed />
          </Suspense>
        ),
      },
      {
        path: "fb-comments",
        element: <FbBuyerDash />,
      },
      {
        path: "fb-comments-classic",
        element: <FbGroupCommentsDashboard />,
      },
      {
        path: "seller-leads",
        element: <FbSellerLeadsDashboard />,
      },
      {
        path: "nd-seller-leads",
        element: <NdSellerLeadsDashboard />,
      },
      {
        path: "marketplace-leads",
        element: <FbMarketplaceLeadsDashboard />,
      },
      {
        path: "discovered-groups",
        element: <FbDiscoveredGroupsDashboard />,
      },
      {
        path: "travelagent",
        element: <TravelAgentDashboard />,
      },
{
  path: "propertyguys/:leadId?",
  element: (
    <Suspense fallback={<FallbackSpinner />}>
      <PropertyGuys />
    </Suspense>
  ),
},
      
      {
        path: "dmedashboard",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Dmedashboard />
          </Suspense>
        ),
      },
      {
        path: "ypgdash",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <PropertyGuysDashboard />
          </Suspense>
        ),
      },
      {
        path: "sellerdash",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <NdSellerDash />
          </Suspense>
        ),
      },
      {
        path: "livedash",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <LiveDash />
          </Suspense>
        ),
      },
      {
        path: "findgroups",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <FindGroups />
          </Suspense>
        ),
      },
      {
        path: "calls",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <CallTrackingDashboard />
          </Suspense>
        ),
      },
      {
        path: "calls/:clientSlug",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <CallTrackingDashboard />
          </Suspense>
        ),
      },
      {
  path: "stripe-return",
  element: <StripeReturn />
},
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "community",
        element: <Community />,
      },
      {
        path: "announcements",
        element: <AnnouncementsPage />,
      },
      
      {
        path: "category/:categoryName/:listingId",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Listing />
          </Suspense>
        ),
      },
      {
        path: "dealexplorerlegacy",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Offers />
          </Suspense>
        ),
      },
      {
        path: "countytest",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            < CountyTest/>
          </Suspense>
        ),
      },
      {
        path: "welcome",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <CityResearch />
          </Suspense>
        ),
      },
      {
        path: "propertylookup",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <PropertyLookup />
          </Suspense>
        ),
      },
      
      {
        path: "fmrexplorer",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <CountyMap />
          </Suspense>
        ),
      },
      {
        path: "dealcalculator",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <DealCalculator />
          </Suspense>
        ),
      },
      {
        path: "rentcast",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <RentCast />
          </Suspense>
        ),
      },
      {
        path: "offmarket",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <OffMarketListings />
          </Suspense>
        ),
      },
      {
        path: "omm",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <PropertysOffMarketMap />
          </Suspense>
        ),
      },
      {
        path: "newdealexplorer",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <ZillowClonePage />
          </Suspense>
        ),
      },
      
      // {
      //   path: "admindashboard",
      //   element: (
      //     <Suspense fallback={<FallbackSpinner />}>
      //       <Dashboard />
      //     </Suspense>
      //   ),
      // },
      {
        path: "dealexplorerai",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <DealExplorer3 />
          </Suspense>
        ),
      },
      {
        path: "dealexplorer",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <DealExplorer2 />
          </Suspense>
        ),
      },
{
  path: "amazon",
  element: (
    <Suspense fallback={<FallbackSpinner />}>
      <Box sx={{ maxWidth: 2000, mx: 'auto', p: 2 }}>
        <AmazonDashboard />
      </Box>
    </Suspense>
  ),
},
      {
        path: "zdf",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <ZillowDescriptionFetcher />
          </Suspense>
        ),
      },
     
      {
        path: "loanportals",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Loans />
            
          </Suspense>
        ),
      },
      {
        path: "skiptrace",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <SkipTrace />
            
          </Suspense>
        ),
      },
      {
        path: "loans",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <RedirectToLoans />
            
          </Suspense>
        ),
      },
      {
        path: "category/:categoryName",
        element: (
          <Suspense fallback={<FallbackSpinner />}>
            <Category />
          </Suspense>
        ),
      },
    ],
  },
  {
  path: "vendor",
  element: (
    <PrivateRoute>
      <VendorLayout />
    </PrivateRoute>
  ),
  children: [
    { index: true, element: <VendorDashboard /> },
    
  ]
},
  {
  path: "internaldash",
  element: (
    <PrivateRoute>
      <VendorLayout />
    </PrivateRoute>
  ),
  children: [
    { index: true, element: <InternalDash /> },
    
  ]
},
  {
  path: "tenant",
  element: (
    <PrivateRoute>
      <TenantLayout />
    </PrivateRoute>
  ),
  children: [
    { index: true, element: <TenantDashboard /> },
    { path: "createRequest", element: <CreateRequest /> },
        { path: 'requests/:id', element: <RequestDetail /> }, // ← NEW
        { path: 'makePayment', element: <MakePayment /> }, // ← NEW
        { path: 'reviewPayment', element: <ReviewPayment /> }, // ← NEW
        { path: 'paymentProcessing', element: <PaymentProcessing /> }, // ← NEW
        { path: 'thankyou', element: <ThankYou /> }, // ← NEW
        { path: 'documents', element: <Documents /> }, // ← NEW
        { path: 'sign-lease', element: <LeaseSigner /> }, // ← NEW

  ]
},
{
  path: "pm",
  element: (
    <PrivateRoute>
      <PMLayout />
    </PrivateRoute>
  ),
  children: [
    { index: true, element: <PropertyManagementDashboard /> },
    { path: "properties", element: <Properties /> },
    { path: "properties/add", element: <AddProperty /> },
    { path: "properties/:address", element: <PropertyDetail /> },
    { path: "properties/:id", element: <PropertyDetailPage /> },
    { path: "tenants", element: <Tenants /> },
    { path: "leases", element: <Leases /> },

    // Leasing
    { path: "leasing/listings", element: <ListingsPage /> },
    { path: "leasing/listings/:id", element: <PropertyDetail /> },
{ path: 'banking/:id', element: <BankDetail /> },
    // Maintenance
    { path: "maintenance", element: <Maintenance /> },
    { path: "maintenance/work-orders", element: <WorkOrdersPage /> },
    { path: "maintenance/work-orders/add", element: <AddWorkOrderPage /> },
    { path: "maintenance/work-orders/:id", element: <PMWorkOrderDetail /> },
    { path: "maintenance/reviewPayment", element: <PMReviewPayment /> },
    { path: "maintenance/paymentProcessing", element: <PMPaymentProcessing /> },
    { path: "maintenance/paymentComplete", element: <PMPaymentComplete /> },
    { path: "maintenance/vendors", element: <VendorsPage /> },
    { path: "maintenance/vendors/add", element: <AddVendorPage /> },
    { path: "maintenance/vendors/:id", element: <VendorDetailScreen /> },

    // Accounting (new)
    { path: "accounting/financials", element: <div>Financials Page</div> },
    { path: "accounting/banking", element: <Banking/> },

    // Other
    { path: "payments", element: <Payments /> },
    { path: "applications", element: <ApplicantsPage /> },
    { path: "applications/:id", element: <ApplicantDetailPage /> },
  ]
}
]);

function App() {
  return (
    <Fragment>
              <LocalizationProvider dateAdapter={AdapterDateFns}>

          <AuthProvider>

      <RouterProvider router={router} />
        <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      </AuthProvider>
                    </LocalizationProvider>


    
    </Fragment>
  )
}

export default App;
